import * as yup from "yup";
import moment from "moment";
import dayjs from "dayjs";

import { DATE_TIME_FORMAT, ERRORS_MESSAGE } from "@bms/constants";
import { isEmpty } from "lodash";

export const validation = (dataLeave: any) => {
  return yup.object().shape({
    // Tab1
    working_status: yup
      .string()
      .nullable()
      .required(ERRORS_MESSAGE["REQUIRED"]),
    invoice_status: yup
      .string()
      .nullable()
      .required(ERRORS_MESSAGE["REQUIRED"]),
    confirm_payment_status: yup
      .string()
      .nullable()
      .required(ERRORS_MESSAGE["REQUIRED"]),

    // Tab2
    order_date: yup.string().nullable().required(ERRORS_MESSAGE["REQUIRED"]),
    building_name: yup
      .string()
      .nullable()
      .max(30, "建物名は30文字以内で入力してください。"),
    room_number: yup
      .string()
      .nullable()
      .max(30, "部屋番号は30文字以内で入力してください。"),
    // building_id: yup.string().nullable().required(ERRORS_MESSAGE["REQUIRED"]),
    // resident_id: yup.string().nullable().required(ERRORS_MESSAGE["REQUIRED"]),
    // support_type: yup
    //   .array()
    //   .nullable()
    //   .min(1, ERRORS_MESSAGE["REQUIRED"])
    //   .required(ERRORS_MESSAGE["REQUIRED"]),
    // address_payment_type: yup
    //   .array()
    //   .nullable()
    //   .min(1, ERRORS_MESSAGE["REQUIRED"])
    //   .required(ERRORS_MESSAGE["REQUIRED"]),
    move_in_date: yup
      .string()
      .nullable()
      .test("", "YYYY-MM-DDの形式で入力してください", (value) => {
        const isValid = dayjs(value, "YYYY-MM-DD", true).isValid();
        if (isEmpty(value)) return true;
        if (value && isValid) return true;
        return false;
      }),

    // Tab3
    department_in_charge: yup
      .string()
      .nullable()
      .required(ERRORS_MESSAGE["REQUIRED"]),
    reception_staff_id: yup
      .string()
      .nullable()
      .required(ERRORS_MESSAGE["REQUIRED"]),
    contact_person: yup.string().nullable(),
    contract_reception_id: yup
      .string()
      .nullable()
      .required(ERRORS_MESSAGE["REQUIRED"]),
    employee_in_charge_id: yup
      .string()
      .test("is-on-leave", dataLeave?.message, (value: any) => {
        if (!value) return true;
        return !(dataLeave?.success && dataLeave?.message);
      }),

    // Tab4
    // request_order_date: yup
    //   .string()
    //   .nullable()
    //   .required(ERRORS_MESSAGE["REQUIRED"]),
    content: yup
      .string()
      .nullable()
      .required(ERRORS_MESSAGE["REQUIRED"])
      .max(500, "相談依頼内容は500文字以内で入力してください。"),
    // start_working_hour: yup.string(),
    //   .nullable()
    //   .required(ERRORS_MESSAGE["REQUIRED"]),
    end_working_hour: yup
      .string()
      .test("", "終了時間は開始時間の後に選択してください。", function (value) {
        const { start_working_hour } = this.parent;
        if (isEmpty(value) && isEmpty(start_working_hour)) {
          return true;
        } else {
          if (start_working_hour && isEmpty(value)) return false;
        }

        return moment(value, DATE_TIME_FORMAT.TIME).isSameOrAfter(
          moment(start_working_hour, DATE_TIME_FORMAT.TIME)
        );
      })
      .nullable(),
    return_end_working_hour: yup
      .string()
      .test("", "終了時間は開始時間の後に選択してください。", function (value) {
        const { return_start_working_hour } = this.parent;
        if (isEmpty(value) && isEmpty(return_start_working_hour)) {
          return true;
        } else {
          if (return_start_working_hour && isEmpty(value)) return false;
        }

        return moment(value, DATE_TIME_FORMAT.TIME).isSameOrAfter(
          moment(return_start_working_hour, DATE_TIME_FORMAT.TIME)
        );
      })
      .nullable(),
    return_order_date: yup
      .string()
      .nullable()
      .when(
        ["request_order_date", "end_working_hour", "return_start_working_hour"],
        (values, schema) => {
          const [
            request_order_date,
            end_working_hour,
            return_start_working_hour,
          ] = values;

          const messageTimeWrong =
            "再訪問日の時間が訪問日の時間と重複しています。再訪問日の時間をご確認ください。";
          return schema.test("", "", function (value) {
            const { createError } = this;

            if (!value || !request_order_date) {
              return true;
            }

            const currentReturnDate = dayjs(value).format("YYYY-MM-DD");
            const requestDate = dayjs(request_order_date).format("YYYY-MM-DD");

            if (currentReturnDate !== requestDate) {
              if (dayjs(currentReturnDate).isAfter(requestDate)) {
                return true;
              } else {
                return createError({
                  message: "再訪問日は訪問日より前の日付で設定できません。",
                });
              }
            } else {
              if (!return_start_working_hour || !end_working_hour) {
                return createError({
                  message: messageTimeWrong,
                });
              }

              const returnStartTime = moment(
                return_start_working_hour,
                "HH:mm"
              );
              const endTime = moment(end_working_hour, "HH:mm");

              if (returnStartTime.isAfter(endTime)) {
                return true;
              } else {
                return createError({
                  message: messageTimeWrong,
                });
              }
            }
          });
        }
      ),
    contruction_subject: yup
      .string()
      .nullable()
      .max(25, "工事件名は25文字以内で入力してください。"),

    // Work Report validation
    work_report_attributes: yup.array().of(
      yup.object().shape({
        title: yup
          .string()
          .nullable()
          .max(500, "作業タイトルは500文字以内で入力してください。"),
        comment: yup
          .string()
          .nullable()
          .max(500, "作業コメントは500文字以内で入力してください。"),
      })
    ),
  });
};
